import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectServiceService {

  private redirectUrl: string | null = null;

  setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  getRedirectUrl(): string | null {
    const url = this.redirectUrl;
    this.redirectUrl = null; // Clear after getting
    return url;
  }

  hasRedirectUrl(): boolean {
    return !!this.redirectUrl;
  }
}
